export function compareRows(listB, listA, isSame) {
  let result = []

  // Para cada objeto em B, busca o correspondente em A.
  for (let b of listB) {
    let a = listA.find((x) => isSame(b, x))
    result.push({ b, a })
  }

  for (let a of listA) {
    let b = listB.find((x) => isSame(x, a))
    if (b == null) result.push({ b, a })
  }

  return result
}

export function missingOne(pair) {
  if (pair.a == null && pair.b != null) return true
  if (pair.a != null && pair.b == null) return true
  return false
}

export function isTech(driver) {
  if ( driver == null ) return false
  return driver.id.toString().startsWith('tech')
}
